import * as React from 'react';
import { Form, FormGroup, ControlLabel, FormControl, Modal, Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import DateTime from 'react-datetime';
import FormSelect from '../../components/common/FormSelect';
import * as Actions from './actions/CalendarActions';
import notify from '../../shared/feedback/notifications';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import moment from 'moment';

interface IActions {
    createSms: (toPhoneNumber: string, body: string, desiredSendTime?: Date) => Promise<any>;
    getTemplates: (photographerId: number) => Promise<any>;
}

interface IRecipient {
    photographerId: number;
    name: string;
    phoneNumber: string;
}

interface IProps {
    actions: IActions;
    onClose: () => void;
    recipient: IRecipient;
    templates: any[];
}

interface IState {
    desiredSendTime: Date;
    body: string;
    datafetched: boolean;
}

class SmsModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            desiredSendTime: null,
            body: '',
            datafetched: false
        };
    }

    componentDidMount() {
        return this.props.actions
            .getTemplates(this.props.recipient.photographerId)
            .then(() => this.setState({ datafetched: true } as IState));
    }

    onDateTimeChange = (moment: any) => {
        this.setState({
            desiredSendTime: moment ? moment.toDate() : null
        } as IState);
    };

    onChange = (e: any) => {
        this.setState({ body: e.target.value } as IState);
    };

    onTemplateChanged = (e: any) => {
        this.setState({
            body: this.props.templates.find((x) => x.name === e.target.value).content
        } as IState);
    };

    sendSms = () => {
        this.props.actions
            .createSms(
                this.props.recipient.phoneNumber,
                this.state.body,
                this.state.desiredSendTime
            )
            .then(() => {
                notify.success(Translate('sms-modal/success'));
                this.props.onClose();
            })
            .catch(() => {
                notify.failure(Translate('sms-modal/error'));
            });
    };

    render() {
        return (
            <div>
                {!this.state.datafetched && (
                    <div style={{ height: '50vh' }}>
                        <Loader loaded={this.state.datafetched}></Loader>
                    </div>
                )}
                <Modal show={this.state.datafetched} onHide={this.props.onClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Translate('sms-modal/title')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <FormGroup>
                                {Translate('sms-modal/recipient', {
                                    name: this.props.recipient.name,
                                    phoneNumber: this.props.recipient.phoneNumber
                                })}
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>{Translate('sms-modal/when')}</ControlLabel>
                                <DateTime
                                    locale={moment.locale()}
                                    onChange={this.onDateTimeChange}
                                />
                            </FormGroup>

                            <FormGroup>
                                <FormGroup>
                                    <ControlLabel>{Translate('sms-modal/template')}</ControlLabel>
                                    <FormSelect
                                        name={'template'}
                                        value={''}
                                        onChange={this.onTemplateChanged}
                                        defaultTranslateKey="sms-modal/template-default"
                                    >
                                        {this.props.templates &&
                                            this.props.templates.map((t, i) => (
                                                <option key={t.name + i} value={t.name}>
                                                    {t.name}
                                                </option>
                                            ))}
                                    </FormSelect>
                                </FormGroup>
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>{Translate('sms-modal/body')}</ControlLabel>
                                <FormControl
                                    componentClass="textarea"
                                    name="body"
                                    value={this.state.body}
                                    onChange={this.onChange}
                                />
                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.onClose}>{Translate('sms-modal/close')}</Button>
                        <Button onClick={this.sendSms} bsStyle="primary">
                            {Translate('sms-modal/send')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        templates: state.photographerCalendars.smsTemplatesForPhotographer
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            createSms: (toPhoneNumber: string, body: string, desiredSendTime?: Date) =>
                dispatch(Actions.createSms(toPhoneNumber, body, desiredSendTime)),
            getTemplates: (photographerId: number) =>
                dispatch(Actions.getSmsTemplates(photographerId))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SmsModal);
